(function ($, njm) {
    'use strict';

    njm.views.articlesHeroDesktop = Backbone.View.extend({

        events: {
            'mouseenter .nav > a': 'setActiveByEvent',
			'focusin .nav > a': 'setActiveByEvent',
			'mouseenter .container': 'stopTimer',
			'mouseleave .container': 'startTimer',
			'blur .nav > a': 'startTimer',
			
        },

        // supported medias for this view
        medias: ['desktop', 'tablet'],

        /**
         * Initialize
         */
        initialize: function () {
			var $this = this;
			
            this.template = $('#comp-articles-hero-desktop').html();

            // Render
            this.render();
			
			this.navCount = this.$('.nav > a').length;
			this.timer = this.$('.comp-articles-hero-desktop').attr('data-autoplay');
			this.timerCounter = 0;
			this.timerInterval = this.$('.comp-articles-hero-desktop').attr('data-autoplay-interval');
			this.hoverActive = false;
			
			if (this.timer.toLowerCase() === 'true') {
				
				this.setInterval = setInterval(function() {
					if($this.hoverActive) {
						return;
					} else if ($this.timerCounter >= $this.timerInterval) {
						$this.setActiveByTimer();
					} else {
						$this.timerCounter += .25;
						//console.log('Timer: ' + $this.timer);
					}
				}, 250);
				
			}
        },

        /**
         * Render
         */
        render: function () {
            this.$el.html(this.template);
        },
		
		setActive: function (target) {
			var $dataId = target.attr('data-id');
			
			//set the .active class only on the hovered element
			this.$('.nav a').removeClass('active');
			target.addClass('active');
			
			//set the .visible class only on the image for the active element
			this.$('.images img').removeClass('visible').addClass('hidden');
			this.$('.images [data-id=' + $dataId + ']').addClass('visible').removeClass('hidden');
		},
		
		setActiveByEvent: function (e) {
			var $target = $(e.currentTarget);
			
			this.timerCounter = 0;
			this.hoverActive = true;
			
			this.setActive($target);
		},
		
		setActiveByTimer: function() {
			var nav = this.$('.nav > a'),
				activeNav = this.$('.nav .active'),
				nextNav;
			
			if (activeNav.next().length === 0) {
				nextNav = $(nav[0]);
			} else {
				nextNav = activeNav.next();
			}
			
			this.setActive(nextNav);
			
			this.timerCounter = 0;
			
		},
		
		stopTimer: function() {
			this.hoverActive = true;
		},
		
		startTimer: function() {
			this.hoverActive = false;
		}
    });
})(jQuery, njm);